import React, { useState } from 'react';
import TinyMCEEditor from './TinyMCEEditor';
import classes from './ContentEditor.module.css';
import { useSelector } from 'react-redux';
import UploadPopup from './UploadPopup/UploadPopup';
import Drag from './Drag';

const ContentEditor = ({ setContentData, data, id }) => {

  const [showImageUploadPopup, setShowImageUploadPopup] = useState();
  const [showVideoUploadPopup, setShowVideoUploadPopup] = useState();

  const { texts } = useSelector(state => state.translate);

  const uplaodBG = (values) => {
    setContentData({ ...data, bgImage: values });
    setShowImageUploadPopup(false)
  }

  const changeData = (content) => {
    setContentData({ ...data, html: content })
  }

  const uplaodVideo = (values) => {
    setContentData({ ...data, video: values });
    setShowVideoUploadPopup(false)
  }

  const changeVideoStyle = (style) => {
    style.url = data.video?.url
    style.isFile = data.video?.isFile
    setContentData({ ...data, video: style });
  }

  const handleDeleteVideo = (event) => {
    if (event.keyCode === 46 || event.keyCode == 8) {
      setContentData({ ...data, video: null });
    }
  }

  const handleVideoClick = (event) => {
    if (event.target === event.currentTarget) {
      event.preventDefault();
    }
  }

  return (
    <div className={classes.ContentEditor}>
      <div className={classes.EditHeader}>
        <button className={classes.Btn} onClick={() => setShowImageUploadPopup(true)} >{texts.addBGImage}</button>
        <button className={classes.Btn} onClick={() => setShowVideoUploadPopup(true)} >{texts.addVideo}</button>
      </div>

      {(showImageUploadPopup || showVideoUploadPopup) &&
        <UploadPopup
          popupType={showImageUploadPopup ? 'image' : 'video'}
          initValues={data && (showImageUploadPopup ? data.bgImage : data.video)}
          addCallback={showImageUploadPopup ? uplaodBG : uplaodVideo}
          close={() => { setShowImageUploadPopup(false); setShowVideoUploadPopup(false) }} />}
      <div className={classes.QuestionnaireBG} style={data && data.bgImage ? { backgroundImage: `url(${data.bgImage.url})`, ...data.bgImage } : {}}>
        {data.video &&
          <Drag change={changeVideoStyle} style={data.video} minSize={100} disableRotate={true} onRemoveRect={() => setContentData({ ...data, video: null })}>
            <div onClick={handleVideoClick} onKeyDown={handleDeleteVideo}>
              {data.video.isFile ?
                <video
                  className={classes.Video}
                  src={data.video.url}
                  style={data.video}
                  onClick={handleVideoClick}
                  controls
                /> :
                <iframe
                  className={classes.Video}
                  src={data.video.url}
                  style={data.video}
                  onClick={handleVideoClick}
                  allowFullScreen
                ></iframe>}
            </div>
          </Drag>}

      </div>
      <div className={classes.BGImage} style={data && data.bgImage ? { backgroundImage: `url(${data.bgImage.url})`, ...data.bgImage } : {}}></div>
      <div className={classes.ContentEditorWrap}>
        <TinyMCEEditor data={data.html} setContentData={changeData} id={id}></TinyMCEEditor>
      </div>
    </div>
  );

}
export default ContentEditor;